import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*() {
  return yield oncallFetch("/api/oncall/partners/cities/list", {});
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/cities/list.js